class PolaroidUpload extends HTMLElement {
    constructor() {
        super();
        this.apiKey = '2e6ff87b56464d7dbc6e2f8af405e4b2';

        this.dropzone = this.querySelector('.polaroid-dropzone');
        this.fileInput = this.querySelector('input[type="file"]');
        this.hiddenInput = this.querySelector('#polaroid-image-url');

        this.previewWrapper = this.querySelector('.polaroid-preview-wrapper');
        this.previewImage = this.querySelector('.polaroid-preview');
        this.removeBtn = this.querySelector('.polaroid-remove-btn');

        this.loadingIndicator = this.querySelector('.polaroid-loading');
        this.errorMessage = this.querySelector('.polaroid-error');
        this.successMessage = this.querySelector('.polaroid-success');
        this.validationError = this.querySelector('.polaroid-validation-error');

        this.bindEvents();
    }

    /**
     * Returns the uploaded image URL, or empty string if none.
     */
    getImageUrl() {
        return this.hiddenInput ? this.hiddenInput.value : '';
    }

    /**
     * Validates that the user has uploaded a photo.
     * Shows a validation message if not.
     * Returns true if valid, false otherwise.
     */
    validate() {
        if (!this.getImageUrl()) {
            this.showValidationError();
            return false;
        }
        this.hideValidationError();
        return true;
    }

    showValidationError() {
        if (this.validationError) {
            this.validationError.style.display = 'flex';
            // Scroll to the component so the user can see the message
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    hideValidationError() {
        if (this.validationError) {
            this.validationError.style.display = 'none';
        }
    }

    bindEvents() {
        if (this.fileInput) {
            this.fileInput.addEventListener('change', this.handleFileSelect.bind(this));
        }

        if (this.dropzone) {
            this.dropzone.addEventListener('dragover', (e) => {
                e.preventDefault();
                this.dropzone.classList.add('dragover');
            });

            this.dropzone.addEventListener('dragleave', (e) => {
                e.preventDefault();
                this.dropzone.classList.remove('dragover');
            });

            this.dropzone.addEventListener('drop', (e) => {
                e.preventDefault();
                this.dropzone.classList.remove('dragover');

                if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                    const file = e.dataTransfer.files[0];
                    this.fileInput.files = e.dataTransfer.files;
                    this.uploadFile(file);
                }
            });
        }

        if (this.removeBtn) {
            this.removeBtn.addEventListener('click', this.resetState.bind(this));
        }
    }

    handleFileSelect(event) {
        const file = event.target.files[0];
        if (file) {
            this.uploadFile(file);
        } else {
            this.resetState();
        }
    }

    async uploadFile(file) {
        // Validate file type
        const validTypes = ['image/jpeg', 'image/png'];
        if (!validTypes.includes(file.type)) {
            this.showError('Por favor, envie apenas imagens JPG ou PNG. O formato GIF não é aceito.');
            return;
        }

        // Hide any previous validation error
        this.hideValidationError();

        // Reset messages and show loading
        this.loadingIndicator.style.display = 'flex';
        this.previewWrapper.style.display = 'none';
        this.errorMessage.style.display = 'none';
        this.successMessage.style.display = 'none';

        // Hide dropzone during upload
        this.classList.add('has-image');

        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch(`https://api.imgbb.com/1/upload?key=${this.apiKey}`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                const imageUrl = data.data.url;
                this.hiddenInput.value = imageUrl;
                this.previewImage.src = imageUrl;
                this.previewWrapper.style.display = 'flex';
                this.successMessage.style.display = 'flex';
            } else {
                throw new Error(data.error?.message || 'Erro ao enviar a imagem.');
            }
        } catch (error) {
            console.error('Erro no upload da imagem:', error);
            this.showError('Erro ao fazer upload da imagem. Verifique a conexão e tente novamente.');
            this.hiddenInput.value = '';
            this.fileInput.value = '';
            this.classList.remove('has-image');
        } finally {
            this.loadingIndicator.style.display = 'none';
        }
    }

    showError(message) {
        this.errorMessage.textContent = message;
        this.errorMessage.style.display = 'block';
        this.loadingIndicator.style.display = 'none';
        this.successMessage.style.display = 'none';
        this.previewWrapper.style.display = 'none';
    }

    resetState() {
        this.hiddenInput.value = '';
        this.fileInput.value = '';
        this.previewImage.src = '';
        this.previewWrapper.style.display = 'none';
        this.loadingIndicator.style.display = 'none';
        this.errorMessage.style.display = 'none';
        this.successMessage.style.display = 'none';
        this.hideValidationError();
        this.classList.remove('has-image');
    }
}

customElements.define('polaroid-upload', PolaroidUpload);
